<!--Form-->
<form autocomplete="nope" #form="ngForm" class="app-grid">
    <p>
        {{ 'payroll.taxForms.youAreAboutToFinalizeAndLockT4s' | translate }}
        <br />
        {{ 'payroll.taxForms.beforeContinuingPleaseConfirmTheFollowing' | translate }}
    </p>
    <mat-checkbox class="columns-12" [(ngModel)]="confirm1" name="confirm1" required
        >{{ 'payroll.taxForms.ihaveCheckedThatAllInformationIsAccurateAndUpToDate' | translate }}
    </mat-checkbox>

    <mat-checkbox class="columns-12" [(ngModel)]="confirm2" name="confirm2" required
        >{{ 'payroll.taxForms.iamAwareThatT4sWillBecomeLockedAfterFinalizing' | translate }}
    </mat-checkbox>

    <mat-checkbox class="columns-12" [(ngModel)]="confirm3" name="confirm3" required
        >{{ 'payroll.taxForms.iamAwareThatImustDownloadAndSubmitTheT619toTheCraUponIssuingT4s' | translate }}
    </mat-checkbox>
</form>
